import { FormField } from "@comps/ui/form";
import { SelectContent, SelectItem, SelectTrigger, SelectValue } from "@comps/ui/select";
import { TYPE_ITEMS_DATE_FORMAT, TYPE_ITEMS_PERIOD_TYPE } from "@dto/fields";
import { DEFAULT_PERIOD_TYPE, PeriodType, PeriodTypeDay, PeriodTypeValues, PeriodTypeWeek } from "@dto/period";
import { Select } from "@radix-ui/react-select";
import { TW_FieldFormatSectionLine_Select, TW_FieldSection_Label, TW_PeriodConfigurationDiv } from "@utils/twClasses";
import { useTranslation } from "react-i18next";
import { FieldTypeItemsFormProps } from "./FieldTypeItemsForm";
import { useEffect, useState } from "react";
import { DEFAULT_DATE_FORMAT } from "@utils/constants";
import { DATE_FORMATS } from "@utils/types";


export function PeriodTypeItemsForm({ form, onTypeItemsChange }: FieldTypeItemsFormProps) {
    const { t } = useTranslation();
    const [periodType, setPeriodType] = useState<PeriodType | undefined>(form.getValues("fieldTypeItems")?.get(TYPE_ITEMS_PERIOD_TYPE) as PeriodType ?? PeriodTypeDay);
    const [dateFormat, setDateFormat] = useState<string | undefined>(form.getValues("fieldFormat")?.get(TYPE_ITEMS_DATE_FORMAT) as string || DEFAULT_DATE_FORMAT);

    useEffect(() => {
        let periodType = form.getValues("fieldTypeItems")?.get(TYPE_ITEMS_PERIOD_TYPE) as PeriodType;
        if (!periodType) {
            periodType = PeriodTypeWeek;
            // let dateFormat = form.getValues("fieldFormat")?.get(TYPE_ITEMS_DATE_FORMAT) as string;
            // if (!dateFormat) {
            //     dateFormat = DEFAULT_DATE_FORMAT;
            // }
            const linkItems = new Map<string, any>(form.getValues("fieldTypeItems"));
            linkItems.set(TYPE_ITEMS_PERIOD_TYPE, periodType);
            // linkItems.set(TYPE_ITEMS_DATE_FORMAT, dateFormat);
            form.setValue("fieldTypeItems", linkItems);
            onTypeItemsChange(linkItems);
        }
        setPeriodType(periodType);
    }, []);

    function onTypeChange(periodTypeStr: string) {
        const periodType = parseInt(periodTypeStr) as PeriodType;
        const linkItems = new Map<string, any>(form.getValues("fieldTypeItems"));
        linkItems.set(TYPE_ITEMS_PERIOD_TYPE, periodType);
        form.setValue("fieldTypeItems", linkItems);
        onTypeItemsChange(linkItems);
        setPeriodType(periodType);
    }

    function onDateFormatChange(event: React.ChangeEvent<HTMLSelectElement>) {
        const dateFormat = event.target.value;
        const linkItems = new Map<string, any>(form.getValues("fieldTypeItems"));
        const newFormat = new Map(form.getValues("fieldFormat"));
        newFormat.set(TYPE_ITEMS_DATE_FORMAT, dateFormat);
        form.setValue("fieldFormat", newFormat);
        onTypeItemsChange(linkItems);
        setDateFormat(dateFormat);
    }

    return (
        <FormField
            control={form.control}
            name="fieldTypeItems"
            render={({ field }) => {
                return (
                    <div className={TW_PeriodConfigurationDiv}>
                        <p className={TW_FieldSection_Label}>{t(`field.period.type.name`)}</p>
                        <Select onValueChange={onTypeChange} value={periodType?.toString() || DEFAULT_PERIOD_TYPE.toString()}>
                            <SelectTrigger>
                                <SelectValue placeholder={t("field.period.type.placeholder")} />
                            </SelectTrigger>
                            <SelectContent>
                                {PeriodTypeValues.filter(type => type !== PeriodTypeDay).map((type: PeriodType) => {
                                    return (
                                        <SelectItem key={type} value={type.toString()}>{t(`field.period.type.${type}`)}</SelectItem>
                                    )
                                })}
                            </SelectContent>
                        </Select>
                        {periodType === PeriodTypeDay && (
                            <select className={TW_FieldFormatSectionLine_Select} value={dateFormat} onChange={onDateFormatChange}>
                                {Array.from(DATE_FORMATS).map(([key, value]) => {
                                    let i18nKey = "date.format.description." + key;
                                    return <option key={"date-format-" + key} value={key} className="text-base">{t(i18nKey)}</option>
                                })}
                            </select>
                        )}
                    </div>
                )
            }
            }
        />
    )
}